/**
 * Figures d'une question isolée (automatismes, test de pack, diagnostic,
 * Warmup) : `visuals` renvoyé par le serveur (migration 0342) = visuels des
 * blocs d'énoncé qui précèdent la question + ceux de la question. Rien si vide.
 */

import type { ExerciseVisualBlock } from '@jeraisonne/ai';
import { VisualBlocksRenderer } from '@jeraisonne/ui';

/** Garde seulement des blocs visuels plausibles (objet avec un `type`). Pure. */
export function questionVisualBlocks(visuals: unknown): ExerciseVisualBlock[] {
  if (!Array.isArray(visuals)) return [];
  return visuals.filter(
    (v): v is ExerciseVisualBlock =>
      !!v && typeof v === 'object' && typeof (v as { type?: unknown }).type === 'string',
  );
}

export function QuestionVisuals({ visuals }: { visuals?: unknown }) {
  const blocks = questionVisualBlocks(visuals);
  if (blocks.length === 0) return null;
  return (
    <div className="mb-4" data-testid="question-visuals">
      <VisualBlocksRenderer blocks={blocks} />
    </div>
  );
}
